import { Component, EventEmitter, Output } from '@angular/core';
import { Section } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { SectionService } from '../../../../services/section.service';

@Component({
	selector: 'app-journey-section-selector',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './journey-section-selector.component.html',
	styleUrl: './journey-section-selector.component.scss',
})
export class JourneySectionSelectorComponent {
	@Output('onSectionSelected') sectionSelected: EventEmitter<Section> = new EventEmitter<Section>();
	@Output('onSectionsLoaded') sectionsLoaded: EventEmitter<Section[]> = new EventEmitter<Section[]>();

	public sections: Section[] = [];
	public loading: boolean = true;

	public selectedSection: Section | undefined;

	constructor(private sectionService: SectionService) {}

	ngOnInit(): void {
		this.reloadSections();
	}

	public async reloadSections(): Promise<void> {
		this.loading = true;

		try {
			this.sections = await this.sectionService.getMySections$(0, 100, true);
			this.sectionsLoaded.emit(this.sections);
		} catch (error) {
			console.error('Error loading sections:', error);
		} finally {
			this.loading = false;
		}
	}

	public selectSection(section: Section): void {
		this.selectedSection = section;

		this.sectionSelected.emit(section);
	}
}
